import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Signal, ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, lastUpdated, children }) {
  useEffect(() => {
    const prev = document.title;
    document.title = `${title} — Telecom BTS`;
    window.scrollTo(0, 0);
    return () => {
      document.title = prev;
    };
  }, [title]);

  return (
    <div className="min-h-dvh bg-[#FAFAFA]">
      <header className="bg-white border-b border-slate-200 sticky top-0 z-30">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-2 text-slate-600 hover:text-emerald-700 transition-colors text-sm font-medium focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded-md px-1"
          >
            <ArrowLeft className="w-4 h-4" aria-hidden="true" />
            Powrót na stronę główną
          </Link>
          <Link to="/" className="flex items-center gap-2 focus:outline-none focus:ring-2 focus:ring-emerald-500 rounded-md">
            <Signal className="w-5 h-5 text-emerald-700" aria-hidden="true" />
            <span className="font-display font-bold text-slate-900 text-sm">
              Telecom <span className="text-emerald-600">BTS</span>
            </span>
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-10 sm:py-14">
        <article className="prose-legal">
          <header className="mb-10 pb-8 border-b border-slate-200">
            <h1 className="text-3xl sm:text-4xl font-black text-slate-900 tracking-tight mb-3">
              {title}
            </h1>
            {lastUpdated && (
              <p className="text-sm text-slate-500">
                Ostatnia aktualizacja: <strong className="font-semibold text-slate-700">{lastUpdated}</strong>
              </p>
            )}
          </header>

          <div className="space-y-8 text-slate-700 leading-relaxed">
            {children}
          </div>

          <div className="mt-14 pt-8 border-t border-slate-200 text-sm text-slate-500 space-y-1">
            <p className="font-semibold text-slate-700">Administrator danych:</p>
            <p>Telecom BTS sp. z o.o.</p>
            <p>ul. Adama Mickiewicza 55, 01-625 Warszawa</p>
            <p>NIP: 525-28-44-929 · KRS: 0000872371 · REGON: 387672774</p>
            <p>E-mail: <a href="mailto:biuro@telecombts.pl" className="text-emerald-700 hover:underline">biuro@telecombts.pl</a></p>
            <p>Telefon: <a href="tel:+48512929641" className="text-emerald-700 hover:underline">+48 512 929 641</a></p>
          </div>
        </article>
      </main>

      <footer className="bg-slate-900 py-8 mt-10">
        <div className="max-w-4xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-slate-400">
          <p>© 2026 Telecom BTS. Wszelkie prawa zastrzeżone.</p>
          <nav className="flex flex-wrap gap-x-5 gap-y-2 justify-center">
            <Link to="/polityka-prywatnosci" className="hover:text-emerald-400 transition-colors">Polityka prywatności</Link>
            <Link to="/regulamin" className="hover:text-emerald-400 transition-colors">Regulamin</Link>
            <Link to="/rodo" className="hover:text-emerald-400 transition-colors">RODO</Link>
            <Link to="/cookies" className="hover:text-emerald-400 transition-colors">Polityka cookies</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export function Section({ children, title }) {
  return (
    <section className="space-y-3">
      <h2 className="text-xl sm:text-2xl font-bold text-slate-900 tracking-tight">{title}</h2>
      <div className="space-y-3 text-[15px]">{children}</div>
    </section>
  );
}
